import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { If } from 'react-extras'
import { connect, useSelector } from 'react-redux'

import { Layout, Popover } from 'antd'
import Auxiliary from 'util/Auxiliary'

import { switchLanguage, toggleCollapsedSideNav } from '../../appRedux/actions'
import AppNotification from '../../components/AppNotification/AppNotification'
import UserInfo from '../../components/UserInfo'
import { getMessage } from '../../util/IntlMessages'
import { isRtv } from '../../util/profiles'
import { BackgroundReportsIcon } from './BackgroundReportsIcon'

const { Header } = Layout

const Topbar = (props) => {
  const [notification, setNotification] = useState({ items: [] })
  const [visiblePopover, setVisiblePopover] = useState(false)
  const [currentPage, setCurrentPage] = useState(0)
  const auth = useSelector((state) => state.auth)

  useEffect(() => {
    if (isRtv(auth.auth)) {
      loadRequest()
    }
  }, [])

  const handleLoadMore = useCallback(() => loadRequest(currentPage + 1), [])

  const loadRequest = useCallback(async (page = 0) => {
    const apiNotification = { items: [] }
    if (page === 0) {
      setNotification(apiNotification)
    }

    setNotification({ items: [...notification.items, ...apiNotification.items] })
    setCurrentPage(page)
  }, [])

  const hidePopover = useCallback(() => setVisiblePopover(false), [])

  const handleVisibleChange = useCallback((visiblePopover) => {
    setVisiblePopover(visiblePopover)
  }, [])

  const showHasNotifications = useMemo(() => {
    const { items } = notification

    if (items.length > 0) {
      return <i className="icon-has-notifications icon-circle" />
    }

    return <div />
  }, [notification])

  return (
    <Auxiliary>
      <Header>
        <div className="gx-linebar gx-mr-3">
          <i
            className="gx-icon-btn icon icon-menu"
            id="gx-icon-btn"
            style={{ marginLeft: '-80%', fontSize: 18, color: '#FFFF' }}
            onClick={() => {
              props.toggleCollapsedSideNav(!props.navCollapsed)
            }}
          />
        </div>
        <ul className="gx-header-notifications gx-ml-auto">
          <If condition={isRtv(auth.auth)}>
            <li className="gx-notify" style={{ color: '#FFFF' }}>
              <Popover
                overlayClassName="gx-popover-horizantal"
                placement="bottomRight"
                content={
                  <AppNotification notifications={notification} hide={hidePopover} handleLoadMore={handleLoadMore} />
                }
                onVisibleChange={handleVisibleChange}
                trigger="click"
                visible={visiblePopover}
              >
                <span className="gx-pointer gx-d-block">
                  {showHasNotifications}
                  <i className="icon icon-notification" />
                </span>
              </Popover>
            </li>
          </If>
          <BackgroundReportsIcon />
          <li title={getMessage('label.topBar.user')} className="gx-user-nav">
            <UserInfo />
          </li>
        </ul>
      </Header>
    </Auxiliary>
  )
}

const mapStateToProps = ({ settings }) => {
  const { locale, navStyle, navCollapsed, width } = settings
  return { locale, navStyle, navCollapsed, width }
}

export default connect(mapStateToProps, { toggleCollapsedSideNav, switchLanguage })(Topbar)
